<section id="speakers">

  <i class="fas speaker-icon fa-microphone text-center"></i>
  <h2 class="section-heading">Plenary / Invited speakers</h2>
  <ul class="list-group text-center">
	<li class="list-group-item">U Ramamurthy, NTU, Singapore</li>
	<li class="list-group-item">Iliya Okulov, Univ. Bremen, Germany</li>
	<li class="list-group-item">Satyam Suwas, IISc, India</li>
	<li class="list-group-item">Edgar Benjamin Montufar Jimenez, Brno University of Tech., Czech Republic</li>
	<li class="list-group-item">R Laxmi Narayanan, IIT Delhi, India</li>
	<li class="list-group-item">Seyed Mohammed Javad Razavi, NTNU, Norway</li>
	<li class="list-group-item">K P Karunakaran, IIT Bombay, India</li>
	<li class="list-group-item">R. Jayaganthan, IIT Madras</li>
	<li class="list-group-item">A. Murugeiyan, IIT Madras</li>
	<li class="list-group-item">Laichang ZHANG, Edith Cowan University, Australia</li>
	<li class="list-group-item">Sankara Narayanan T.S.N., University of Madras, India</li>
	<li class="list-group-item">Rangasayee Kannan, Oak Ridge National Laboratory, USA </li>
  </ul>
  <br/>

</section>
<style>
	section {
		padding-top: 86px;
		text-align: center;
	}
	i {
		display: block;
		margin: 0 auto;
		font-size: 2rem;
		padding-bottom: 1em;
	}
	h2 {
		text-align: center;
	}
	p {
		text-align: center;
		width: 80%;
		margin: 0 auto;
		font-size: 1.1em;
	}

	@media all and (min-width: 768px) {
	  p {
	    width: 60%;
	  }
	}
</style>
